import React, { useCallback, useState } from 'react';

import { useWelcomeBonusQuery } from 'api/queries/bankrollQueries';
import { CODE_REQUIRED_OVERLAY } from 'config/constants';
import { clearBankrollCode } from 'reduxState/currentUserData/userBankroll';
import { staticDispatch } from 'reduxState/store';
import { useSelector } from 'reduxState/storeCore';

import BankrollAppliedModal from './BankrollAppliedModal';
import BankrollCustomRatesAppliedModal from './BankrollCustomRatesAppliedModal';
import BankrollModal from './BankrollModal';
import WelcomePointsModal from './WelcomePointsModal';

export default function BankrollWorker() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const bankrollCodeToApply = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeToApply
  );
  const bankrollCodeToApplyType = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeType
  );
  const bankrollCodeApplied = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeApplied
  );
  const bankrollCodeAppliedMessage = useSelector(
    state => state.currentUserData.userBankroll.bankrollCodeAppliedMessage
  );
  const bankrollAddedInThisSession = useSelector(
    state => state.currentUserData.userBankroll.bankrollAddedInThisSession
  );

  const { data: appliedWelcomeBonusData } =
    useWelcomeBonusQuery(bankrollCodeApplied);

  const [closedPerWallet, setClosedPerWallet] = useState('-');

  const handleClose = useCallback(
    () => setClosedPerWallet(walletAddress),
    [walletAddress]
  );

  if (bankrollCodeApplied) {
    const handleCloseAppliedModal = () => staticDispatch(clearBankrollCode());

    if (!appliedWelcomeBonusData) {
      // Loading data...
      return null;
    }

    const { referralRateOverride, referredDiscountRateOverride } =
      appliedWelcomeBonusData.welcomeBonus || {};

    if (referralRateOverride || referredDiscountRateOverride) {
      return (
        <BankrollCustomRatesAppliedModal
          referralRateOverride={referralRateOverride}
          referredDiscountRateOverride={referredDiscountRateOverride}
          message={
            bankrollCodeAppliedMessage ||
            appliedWelcomeBonusData.welcomeBonus?.message
          }
          onClose={handleCloseAppliedModal}
        />
      );
    }
    return (
      <BankrollAppliedModal
        bankrollCode={
          bankrollCodeToApplyType === 'welcomePoints'
            ? undefined
            : bankrollCodeApplied
        }
        message={bankrollCodeAppliedMessage}
        onClose={handleCloseAppliedModal}
      />
    );
  }

  if (
    bankrollCodeToApplyType === 'welcomePoints' &&
    closedPerWallet !== walletAddress
    // (bankrollAddedInThisSession || walletAddress)
  ) {
    return (
      <WelcomePointsModal
        pointsBonusCode={bankrollCodeToApply}
        onClose={CODE_REQUIRED_OVERLAY ? undefined : handleClose}
      />
    );
  }

  if (
    bankrollCodeToApplyType === 'bankroll' &&
    bankrollCodeToApply &&
    closedPerWallet !== walletAddress &&
    (bankrollAddedInThisSession || walletAddress)
  ) {
    return (
      <BankrollModal bankrollCode={bankrollCodeToApply} onClose={handleClose} />
    );
  }

  return null;
}
